"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SampleDataView_1 = require("./SampleDataView");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return SampleDataView_1.default; } });
